import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['button', 'menu', 'item', 'input'];

  connect() {
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    document.addEventListener('dropdown:open', this.handleOtherDropdownOpen.bind(this));
    const item = this.itemTargets.find((item) => item.dataset.value === this.data.get('value'));
    const buttonText = this.buttonTarget.querySelector('span:first-child');
    if (buttonText) {
      buttonText.textContent = item ? item.textContent : 'Select...';
    }
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
    document.removeEventListener('dropdown:open', this.handleOtherDropdownOpen.bind(this));
  }

  select(event) {
    event.stopPropagation();
    const buttonText = this.buttonTarget.querySelector('span:first-child');
    if (buttonText) {
      buttonText.textContent = event.target.textContent;
    }
    this.inputTarget.value = event.target.dataset.value;
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.data.set('value', event.target.dataset.value);
    this.menuTarget.classList.add('hidden');
  }

  toggle(event) {
    event.stopPropagation();
    if (this.menuTarget.classList.contains('hidden')) {
      document.dispatchEvent(new CustomEvent('dropdown:open', { detail: { controller: this } }));
    }
    this.menuTarget.classList.toggle('hidden');
  }

  handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add('hidden');
    }
  }

  handleOtherDropdownOpen(event) {
    if (event.detail.controller !== this) {
      this.menuTarget.classList.add('hidden');
    }
  }
}
